import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const teal = "#06d1c6";
const whatsAppGreen = "#25D366";

export default function AdminWhatsAppScheduler() {
  const [activeTab, setActiveTab] = useState("campaigns"); // "campaigns" | "templates"

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          {/* Breadcrumb - minimal, above the main card */}
          <div className="mb-3" style={{ padding: "0 4px" }}>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  WhatsApp Scheduler
                </li>
              </ol>
            </nav>
          </div>

          {/* Main card: Tabs + Help links + Content */}
          <div style={cardStyle}>
            {/* Header: Tabs (left) + Watch Tutorial / Usage Guide (right) */}
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-4">
              <div className="d-flex">
                <button
                  type="button"
                  onClick={() => setActiveTab("campaigns")}
                  className="border-0 bg-transparent pb-2 px-0 me-4"
                  style={{
                    fontWeight: 600,
                    fontSize: "15px",
                    color: activeTab === "campaigns" ? teal : "#94a3b8",
                    borderBottom: activeTab === "campaigns" ? `3px solid ${teal}` : "3px solid transparent",
                    cursor: "pointer",
                  }}
                >
                  Campaigns
                </button>
                <button
                  type="button"
                  onClick={() => setActiveTab("templates")}
                  className="border-0 bg-transparent pb-2 px-0"
                  style={{
                    fontWeight: 600,
                    fontSize: "15px",
                    color: activeTab === "templates" ? teal : "#94a3b8",
                    borderBottom: activeTab === "templates" ? `3px solid ${teal}` : "3px solid transparent",
                    cursor: "pointer",
                  }}
                >
                  Templates
                </button>
              </div>
              <div className="d-flex align-items-center gap-3">
                <a
                  href="#watch-tutorial"
                  className="d-flex align-items-center gap-2 text-decoration-none"
                  style={{ color: teal, fontWeight: 600, fontSize: "14px" }}
                >
                  <span
                    style={{
                      width: 28,
                      height: 28,
                      borderRadius: "50%",
                      background: "rgba(6, 209, 198, 0.15)",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "12px",
                    }}
                  >
                    <i className="fa-solid fa-play" />
                  </span>
                  Watch Tutorial
                </a>
                <a
                  href="#usage-guide"
                  className="text-decoration-none"
                  style={{ color: teal, fontWeight: 600, fontSize: "14px" }}
                >
                  Usage Guide
                </a>
              </div>
            </div>

            {/* Campaigns tab: Phone mockup + description + Create Campaign button */}
            {activeTab === "campaigns" && (
              <div className="text-center" style={{ padding: "32px 24px 40px" }}>
                {/* Phone mockup */}
                <div
                  style={{
                    display: "inline-block",
                    marginBottom: "32px",
                    borderRadius: "28px",
                    padding: "12px",
                    background: "linear-gradient(145deg, #c71585 0%, #a0126a 100%)",
                    boxShadow: "0 12px 40px rgba(0,0,0,0.15)",
                  }}
                >
                  <div
                    style={{
                      width: 260,
                      maxWidth: "100%",
                      borderRadius: "20px",
                      overflow: "hidden",
                      border: "3px solid #1a1a1a",
                      background: "#fff",
                    }}
                  >
                    {/* Status bar */}
                    <div
                      style={{
                        padding: "8px 12px 6px",
                        background: "#075e54",
                        color: "rgba(255,255,255,0.9)",
                        fontSize: "11px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>20:00</span>
                      <span>
                        <i className="fa-solid fa-signal me-1" />
                        <i className="fa-solid fa-wifi me-1" />
                        <i className="fa-solid fa-battery-full" />
                      </span>
                    </div>
                    {/* Chat header */}
                    <div
                      style={{
                        padding: "10px 12px",
                        background: "#075e54",
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        fontSize: "14px",
                      }}
                    >
                      <i className="fa-solid fa-arrow-left" style={{ opacity: 0.9 }} />
                      <span style={{ flex: 1, fontWeight: 600 }}>Contact Name</span>
                      <i className="fa-solid fa-video" style={{ opacity: 0.9 }} />
                      <i className="fa-solid fa-phone" style={{ opacity: 0.9 }} />
                      <i className="fa-solid fa-ellipsis-v" style={{ opacity: 0.9 }} />
                    </div>
                    {/* Chat area - placeholder image + lines */}
                    <div style={{ padding: "12px", background: "#e5ddd5", minHeight: 180 }}>
                      <div
                        style={{
                          width: "100%",
                          height: 100,
                          borderRadius: "8px",
                          background: "linear-gradient(135deg, #10b981 0%, #0ea5e9 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginBottom: "10px",
                          color: "#fff",
                          fontSize: "24px",
                        }}
                      >
                        <i className="fa-solid fa-chart-line" />
                      </div>
                      <div style={{ background: "#fff", borderRadius: "8px", padding: "8px 10px", marginBottom: "6px", width: "85%", height: 10 }} />
                      <div style={{ background: "#fff", borderRadius: "8px", padding: "8px 10px", marginBottom: "6px", width: "70%", height: 10 }} />
                      <div style={{ background: "#fff", borderRadius: "8px", padding: "8px 10px", width: "60%", height: 10 }} />
                    </div>
                    {/* Message input bar */}
                    <div
                      style={{
                        padding: "8px 10px",
                        background: "#f0f2f5",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        borderTop: "1px solid #e0e0e0",
                      }}
                    >
                      <i className="fa-regular fa-face-smile" style={{ color: "#54656f", fontSize: "18px" }} />
                      <span style={{ flex: 1, fontSize: "13px", color: "#667781" }}>Message</span>
                      <i className="fa-solid fa-paperclip" style={{ color: "#54656f", fontSize: "14px" }} />
                      <i className="fa-solid fa-camera" style={{ color: "#54656f", fontSize: "14px" }} />
                      <span
                        style={{
                          width: 36,
                          height: 36,
                          borderRadius: "50%",
                          background: whatsAppGreen,
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#fff",
                          fontSize: "16px",
                        }}
                      >
                        <i className="fa-solid fa-microphone" />
                      </span>
                    </div>
                  </div>
                </div>

                <p style={{ fontSize: "16px", color: "#334155", marginBottom: "24px", maxWidth: 420, marginLeft: "auto", marginRight: "auto" }}>
                  Create and send WhatsApp campaigns to your investors.
                </p>

                <button
                  type="button"
                  style={{
                    background: teal,
                    color: "#fff",
                    border: "none",
                    padding: "12px 28px",
                    borderRadius: "8px",
                    fontWeight: 600,
                    fontSize: "15px",
                    cursor: "pointer",
                  }}
                >
                  Create Campaign
                </button>
              </div>
            )}

            {/* Templates tab - placeholder */}
            {activeTab === "templates" && (
              <div style={{ padding: "48px 24px", textAlign: "center", color: "#64748b" }}>
                <p className="mb-0">Templates content can be added here.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
